import { UserAccount } from '../entities/users';

/**
 * ユーザーアカウント情報を扱うサービス
 */
export class UserAccountService {
  /**
   * ユーザーアカウントの表示名を取得する
   * @param userAccount - ユーザーアカウント
   */
  public static getDisplayName = (userAccount: UserAccount): string => {
    if (userAccount.name && userAccount.name.length > 0) {
      // 名前がある場合は名前を優先して表示
      return userAccount.name;
    }
    if (userAccount.email && userAccount.email.length > 0) {
      // 名前が無い場合はメールアドレスを表示
      return userAccount.email;
    }
    return '';
  };

  /**
   * ユーザーリストの表示情報を取得
   * @param userAccounts - ユーザー情報
   */
  public static getDisplayUsers = (userAccounts: UserAccount[]): string => {
    return userAccounts.map((u) => this.getDisplayName(u)).join(',') || '--';
  };
}
